import { Select, SelectProps, Tooltip } from "antd";
import { useId } from "react";
import { Nullable } from "../../../applications/constants/AppTypes";
import "./AppDropdown.scss";

interface AppDropdownProps<DataType> extends SelectProps<DataType> {
  label?: string;
  currentValue: Nullable<DataType>;
  onChangeValue?: (newValue: DataType) => void;
  errorText?: string;
  getOptionKey?: (item: DataType) => string | number; // nếu muốn sử dụng genric với value không phải là string | number thì cần truyền vào để lấy key
}

export function AppDropdown<DataType>(props: AppDropdownProps<DataType>) {
  const {
    className,
    errorText,
    label,
    currentValue,
    onChangeValue,
    options = [],
    getOptionKey,
    ...rest
  } = props;

  const isLargeList = (options?.length || 0) > 10;

  const elementId = useId();

  const isOptionsIncludeCurrentValue = options?.some((e) => e.value === currentValue);

  return (
    <Tooltip title={!!errorText ? errorText : ""} placement="top">
      <Select
        id={props.id || elementId}
        className={`app-select-selector ${className || ""} `}
        status={!!errorText ? "error" : undefined}
        value={isOptionsIncludeCurrentValue ? currentValue : null}
        onChange={(value) => {
          onChangeValue?.(value);
        }}
        filterOption={(input, option) => {
          if (option?.label) {
            return (option.label as string)?.toLowerCase().includes(input.toLowerCase());
          }
          return false;
        }}
        options={options}
        virtual={isLargeList}
        {...rest}
      />
    </Tooltip>
  );
}

export default AppDropdown;
